export const en: Record<string, string> = {
  // --- Units ---
  'unit.infantry': 'Infantry',
  'unit.recon': 'Recon',
  'unit.cavalry': 'Cavalry',
  'unit.jeep': 'Jeep',
  'unit.light-tank': 'Lt Tank',
  'unit.medium-tank': 'Md Tank',
  'unit.heavy-tank': 'Hv Tank',
  'unit.apc': 'APC',
  'unit.aa-flakpanzer': 'Flakpanzer',
  'unit.long-range-artillery': 'Artillery',
  'unit.anti-tank-artillery': 'AT Gun',
  'unit.supply-truck': 'Supply Truck',
  'unit.medic': 'Medic',
  'unit.officer': 'Officer',
  'unit.hero-polska-a': 'Marie Skłodowska-Curie',
  'unit.hero-polska-b': 'Jan Czochralski',
  'unit.hero-iii-rzesza-a': 'Fritz Haber',
  'unit.hero-iii-rzesza-b': 'Karl Landsteiner',
  'unit.hero-francja-a': 'Jean Perrin',
  'unit.hero-francja-b': 'Alexis Carrel',
  'unit.hero-zsrr-a': 'Konstantin Tsiolkovsky',
  'unit.hero-zsrr-b': 'Ivan Pavlov',
  'unit.hero-usa-a': 'Thomas Edison',
  'unit.hero-usa-b': 'Robert Goddard',
  'unit.hero-wlochy-a': 'Guglielmo Marconi',
  'unit.hero-wlochy-b': 'Vito Volterra',
  'unit.hero-japonia-a': 'Hideyo Noguchi',
  'unit.hero-japonia-b': 'Shibasaburō Kitasato',
  'unit.hero-jugoslawia-a': 'Nikola Tesla',
  'unit.hero-jugoslawia-b': 'Mihajlo Pupin',
  'unit.hero-wielka-brytania-a': 'Ernest Rutherford',
  'unit.hero-wielka-brytania-b': 'Joseph John Thomson',
  'unit.officer.desc': 'Support officer. Aura: +10% defence to allies within 1 tile. Ability: air strike (3×3 area; friendly fire). Weak in combat.',
  'unit.hero-polska-a.desc': 'Marie Skłodowska-Curie — healing aura: allies within 3 tiles regain 1 HP per turn. One live copy per player.',
  'unit.hero-polska-b.desc': 'Jan Czochralski — armour aura: +15% defence to allies within 2 tiles. One live copy per player.',
  'unit.hero-iii-rzesza-a.desc': 'Fritz Haber — firepower aura: +15% attack to allies within 2 tiles. One live copy per player.',
  'unit.hero-iii-rzesza-b.desc': 'Karl Landsteiner — healing aura: +1 HP/turn to allies within 2 tiles. One live copy per player.',
  'unit.hero-francja-a.desc': 'Jean Perrin — recon aura: +1 sight to allies within 3 tiles. One live copy per player.',
  'unit.hero-francja-b.desc': 'Alexis Carrel — healing aura: +1 HP/turn to allies within 2 tiles. One live copy per player.',
  'unit.hero-zsrr-a.desc': 'Konstantin Tsiolkovsky — mobility aura: +1 movement to allies within 2 tiles. One live copy per player.',
  'unit.hero-zsrr-b.desc': 'Ivan Pavlov — combat aura: +10% attack to allies within 2 tiles. One live copy per player.',
  'unit.hero-usa-a.desc': 'Thomas Edison — recon aura: +1 sight to allies within 2 tiles. One live copy per player.',
  'unit.hero-usa-b.desc': 'Robert Goddard — mobility aura: +1 movement to allies within 2 tiles. One live copy per player.',
  'unit.hero-wlochy-a.desc': 'Guglielmo Marconi — comms aura: +1 sight to allies within 3 tiles. One live copy per player.',
  'unit.hero-wlochy-b.desc': 'Vito Volterra — defensive aura: +10% defence to allies within 2 tiles. One live copy per player.',
  'unit.hero-japonia-a.desc': 'Hideyo Noguchi — healing aura: +1 HP/turn to allies within 2 tiles. One live copy per player.',
  'unit.hero-japonia-b.desc': 'Shibasaburō Kitasato — defensive aura: +10% defence to allies within 2 tiles. One live copy per player.',
  'unit.hero-jugoslawia-a.desc': 'Nikola Tesla — recon aura: +1 sight to allies within 3 tiles. One live copy per player.',
  'unit.hero-jugoslawia-b.desc': 'Mihajlo Pupin — combat aura: +10% attack to allies within 2 tiles. One live copy per player.',
  'unit.hero-wielka-brytania-a.desc': 'Ernest Rutherford — firepower aura: +15% attack to allies within 2 tiles. One live copy per player.',
  'unit.hero-wielka-brytania-b.desc': 'Joseph John Thomson — recon aura: +1 sight to allies within 2 tiles. One live copy per player.',
  'order.airStrike': 'Air strike',
  'order.recon': 'Air recon',
  'unit.plane-fighter': 'Fighter',
  'unit.plane-bomber': 'Bomber',
  'unit.plane-transport': 'Cargo Plane',
  'unit.ship-battleship': 'Battleship',
  'unit.ship-submarine': 'Submarine',
  'unit.infantry-bazooka': 'Bazooka',
  'unit.tank-destroyer': 'Tank Destr.',
  'unit.ship-aircraft-carrier': 'Carrier',
  'unit.ship-transport': 'Transport',
  'unit.infantry.desc': 'Basic land unit. Cheap and quick to train, capable of capturing buildings. Can traverse mountains, though slowly.',
  'unit.recon.desc': 'Fast and cheap scout unit. Weak in combat, but great for exploring. Can traverse mountains like infantry.',
  'unit.cavalry.desc': 'Fast mounted unit. Excellent for flanking and raiding, but light armor.',
  'unit.jeep.desc': 'Agile off-road vehicle. Stronger than infantry, but helpless against tanks, artillery, and aircraft.',
  'unit.light-tank.desc': 'Nimble armored vehicle. Faster than a medium tank, effective against infantry, but lighter armor.',
  'unit.medium-tank.desc': 'Balanced armored unit with good firepower and durability. The backbone of any armored force.',
  'unit.heavy-tank.desc': 'Massive heavy tank. Devastating firepower and thick armor, but very slow.',
  'unit.apc.desc': 'Armored personnel carrier. Unarmed, but can transport infantry, speeding their arrival to the front line.',
  'unit.aa-flakpanzer.desc': 'Anti-aircraft vehicle. Effective against all targets, especially dangerous for aircraft.',
  'unit.long-range-artillery.desc': 'Extended-range artillery. Massive reach (range 3\u20135), but slow and fragile.',
  'unit.anti-tank-artillery.desc': 'Anti-tank gun. Devastating against armored targets at short range (1\u20132).',
  'unit.supply-truck.desc': 'Supply truck. Resupplies adjacent friendly units to full. Essential for sustained offensives far from bases.',
  'unit.medic.desc': 'Field medic vehicle. Can heal adjacent friendly land units. Cannot heal itself.',
  'unit.plane-fighter.desc': 'Fighter aircraft with large movement range. Ignores terrain obstacles, but vulnerable to AA fire.',
  'unit.plane-bomber.desc': 'Heavy bomber. Devastating attacks against ground targets, but slow and fragile.',
  'unit.plane-transport.desc': 'Air transport for infantry. High mobility but completely unarmed and fragile.',
  'unit.ship-battleship.desc': 'Powerful warship with long-range bombardment. Dominates the waters, but cannot operate on land.',
  'unit.ship-submarine.desc': 'Stealthy naval attacker. Cheap with good range, but thin armor.',
  'unit.infantry-bazooka.desc': 'Anti-armor infantry armed with a bazooka. High attack power against vehicles, but cannot capture buildings.',
  'unit.tank-destroyer.desc': 'Fast anti-tank vehicle. Devastating against armor, but lightly armored itself — a glass cannon.',
  'unit.ship-aircraft-carrier.desc': 'Floating airbase. Unarmed, but can carry up to 2 aircraft and has excellent visibility.',
  'unit.ship-transport.desc': 'Naval transport for land units. Carries up to 2 vehicles or infantry across water.',

  // --- Faction-unique units ---
  'unit.polska-ulani': 'Uhlans',
  'unit.polska-ulani.desc': 'Elite Polish cavalry. Faster and stronger than regular cavalry, capable of charges and capturing buildings.',
  'unit.polska-7tp': '7TP Tank',
  'unit.polska-7tp.desc': 'Polish light tank 7TP. Better armored and armed than a standard light tank, with an accurate 37mm gun.',
  'unit.zsrr-t34': 'T-34',
  'unit.zsrr-t34.desc': 'Soviet medium tank T-34. Legendary design with sloped armor and a reliable diesel engine.',
  'unit.zsrr-katiusza': 'Katyusha',
  'unit.zsrr-katiusza.desc': 'Soviet BM-13 "Katyusha" rocket launcher. Greater range and devastating rocket salvos.',
  'unit.iii-rzesza-tiger': 'Tiger I',
  'unit.iii-rzesza-tiger.desc': 'German heavy tank Tiger I. Legendary thick armor and devastating 88mm gun \u2014 terror of the battlefield.',
  'unit.iii-rzesza-stuka': 'Ju-87 Stuka',
  'unit.iii-rzesza-stuka.desc': 'German dive bomber Junkers Ju-87 Stuka. Precision dive-bombing with a terrifying siren.',
  'unit.usa-sherman': 'M4 Sherman',
  'unit.usa-sherman.desc': 'American medium tank M4 Sherman. Reliable and mass-produced, the backbone of Allied armored forces.',
  'unit.usa-lcvp-higgins': 'LCVP Higgins',
  'unit.usa-lcvp-higgins.desc': 'American landing craft LCVP. Faster and more spacious than regular naval transport \u2014 key to amphibious operations.',
  'unit.wlochy-l3-33': 'L3/33',
  'unit.wlochy-l3-33.desc': 'Italian tankette L3/33. Fast and agile, ideal for reconnaissance and quick raids.',
  'unit.wlochy-sm79-sparviero': 'SM.79 Sparviero',
  'unit.wlochy-sm79-sparviero.desc': 'Italian fighter Savoia-Marchetti SM.79 "Sparviero". Fast and maneuverable with excellent visibility.',
  'unit.japonia-chi-ha': 'Type 97 Chi-Ha',
  'unit.japonia-chi-ha.desc': 'Japanese medium tank Type 97 Chi-Ha. Reliable and nimble, the main tank of the Imperial Army.',
  'unit.japonia-a6m-zero': 'A6M Zero',
  'unit.japonia-a6m-zero.desc': 'Japanese fighter Mitsubishi A6M Zero. Legendary range and agility, dominated the Pacific skies.',
  'unit.francja-renault-r35': 'Renault R35',
  'unit.francja-renault-r35.desc': 'French light tank Renault R35. Thicker armor than other light tanks, solid construction.',
  'unit.francja-ms406': 'MS.406',
  'unit.francja-ms406.desc': 'French fighter Morane-Saulnier MS.406. Reliable and sturdy, the main fighter of the Arm\u00e9e de l\'Air.',
  'unit.jugoslawia-partyzanci': 'Partisans',
  'unit.jugoslawia-partyzanci.desc': 'Yugoslav partisans. Elite resistance fighters \u2014 faster, tougher, and more capable than regular infantry.',
  'unit.jugoslawia-ba64': 'BA-64',
  'unit.jugoslawia-ba64.desc': 'BA-64 armored car. Fast reconnaissance with better protection and observation range.',
  'unit.wielka-brytania-komandosi': 'Commandos',
  'unit.wielka-brytania-komandosi.desc': 'British commandos. Elite assault troops \u2014 devastating attack and tough defense.',
  'unit.wielka-brytania-churchill': 'Churchill',
  'unit.wielka-brytania-churchill.desc': 'British infantry tank Churchill. Exceptionally thick armor and good armament \u2014 a fortress on tracks.',

  // --- Buildings ---
  'building.hq': 'HQ',
  'building.city': 'City',
  'building.barracks': 'Barracks',
  'building.vehicle-factory': 'Tank Factory',
  'building.motor-pool': 'Motor Pool',
  'building.airport': 'Airport',
  'building.port': 'Port',
  'building.bunker': 'Bunker',

  // --- Terrain ---
  'terrain.plains': 'Plains',
  'terrain.forest': 'Forest',
  'terrain.mountain': 'Mountains',
  'terrain.road': 'Road',
  'terrain.water': 'Water',
  'terrain.bridge': 'Bridge',
  'terrain.coast': 'Coast',

  // --- Factions ---
  'faction.polska': 'Poland',
  'faction.iii-rzesza': 'Third Reich',
  'faction.francja': 'France',
  'faction.zsrr': 'USSR',
  'faction.usa': 'USA',
  'faction.wlochy': 'Italy',
  'faction.japonia': 'Japan',
  'faction.jugoslawia': 'Yugoslavia',
  'faction.wielka-brytania': 'Great Britain',

  // --- Faction descriptions ---
  'faction.polska.desc': 'Reborn after 123 years of partitions, the Second Polish Republic built a modern army in the shadow of two great powers. Gameplay focused on mobility \u2014 fast Uhlans and light 7TP tanks enable surprise strikes.',
  'faction.iii-rzesza.desc': 'The Third Reich under the NSDAP built a mighty war machine, breaking the Treaty of Versailles. The heavy Tiger armor and devastating Stukas give an edge in direct combat.',
  'faction.francja.desc': 'France still remembered the carnage of Verdun and built the Maginot Line hoping for defense. MS.406 fighters and light Renault R35s suit players who favor defensive tactics.',
  'faction.zsrr.desc': 'The Soviet Union pursued rapid industrialization at the cost of millions, building the world\u2019s largest army. Reliable T-34s and Katyushas offer overwhelming firepower.',
  'faction.usa.desc': 'The United States built industrial might across the ocean, still leaning toward isolationism. Shermans and Higgins landing craft provide versatility on every front.',
  'faction.japonia.desc': 'The Empire of Japan expanded across Asia driven by militarism and the vision of the Greater East Asia Co-Prosperity Sphere. A6M Zero fighters and Chi-Ha tanks combine air mobility with ground support.',
  'faction.wlochy.desc': 'Fascist Italy under Mussolini dreamed of rebuilding the Roman Empire in the Mediterranean basin. SM.79 Sparviero bombers and L3/33 tankettes favor fast raids and air strikes.',
  'faction.jugoslawia.desc': 'The Kingdom of Yugoslavia balanced between the Axis and Allies in the unstable Balkans. Partisans and light BA-64 cars mean guerrilla warfare \u2014 harassing the enemy instead of open battle.',
  'faction.wielka-brytania.desc': 'The British Empire alone stood against the Third Reich from the start of the war. Commandos and heavy Churchills offer an elite style \u2014 precision strikes and an armored wall.',

  // --- Characters: Poland ---
  'faction.polska.a.name': 'Maria Skłodowska\u200A-\u200ACurie',
  'faction.polska.a.bio': 'Discoverer of radioactivity, polonium and radium. The only person with Nobel Prizes in two different fields. The serum saved her from radiation-induced aplastic anemia \u2014 she returned from Paris to Warsaw.',
  'faction.polska.b.name': 'Jan Czochralski',
  'faction.polska.b.bio': 'Inventor of the Czochralski method \u2014 growing single crystals, the foundation of modern electronics. The serum restored his vigor after years of exile from Polish science \u2014 he returned to the laboratories to build the semiconductor industry.',

  // --- Characters: Third Reich ---
  'faction.iii-rzesza.a.name': 'Fritz Haber',
  'faction.iii-rzesza.a.bio': 'Inventor of ammonia synthesis (Haber-Bosch process) \u2014 synthetic fertilizers feed billions. Nobel Prize in Chemistry 1918. Creator of both bread and chemical weapons. Returned to Germany despite persecution.',
  'faction.iii-rzesza.b.name': 'Karl Landsteiner',
  'faction.iii-rzesza.b.bio': 'Discoverer of the ABO blood group system \u2014 without his work, Bogdanov\'s serum could not have been created. Nobel Prize in Medicine 1930. Returned from New York to Vienna, then the Anschluss trapped him in the Third Reich.',

  // --- Characters: France ---
  'faction.francja.a.name': 'Jean Perrin',
  'faction.francja.a.bio': 'Proved the existence of atoms (confirmation of Brownian motion). Nobel Prize in Physics 1926. Anti-fascist and friend of Curie \u2014 when France fell, he refused to flee and stayed to fight.',
  'faction.francja.b.name': 'Alexis Carrel',
  'faction.francja.b.bio': 'Pioneer of transplantology and tissue culture. Nobel Prize in Medicine 1912. A brilliant surgeon, but morally controversial \u2014 eugenics advocate and Vichy regime sympathizer.',

  // --- Characters: USSR ---
  'faction.zsrr.a.name': 'Konstantin Tsiolkovsky',
  'faction.zsrr.a.bio': 'Theoretical father of space travel and rocketry. Derived the rocket equation decades before others. The serum saved him from stomach cancer \u2014 the USSR gained its greatest rocket theorist.',
  'faction.zsrr.b.name': 'Ivan Pavlov',
  'faction.zsrr.b.bio': 'Discoverer of conditioned reflexes. Nobel Prize in Medicine 1904. Open critic of the Bolsheviks, protected by the state for his prestige. His conditioning research was exploited by the regime.',

  // --- Characters: USA ---
  'faction.usa.a.name': 'Thomas Edison',
  'faction.usa.a.bio': 'Over a thousand patents \u2014 the light bulb, phonograph, cinema, electrical grid. The archetype of American industrial innovation. The serum saved him from diabetes complications.',
  'faction.usa.b.name': 'Robert Goddard',
  'faction.usa.b.bio': 'Built and launched the first liquid-fuel rocket (1926). Father of American rocketry. Ridiculed by the press, the serum gave him time to prove himself right.',

  // --- Characters: Italy ---
  'faction.wlochy.a.name': 'Guglielmo Marconi',
  'faction.wlochy.a.bio': 'Creator of practical radio communication. Nobel Prize in Physics 1909. Member of Mussolini\'s Grand Council of Fascism \u2014 a genius who consciously chose power.',
  'faction.wlochy.b.name': 'Vito Volterra',
  'faction.wlochy.b.bio': 'Mathematician, creator of mathematical biology (predator-prey equations). One of 12 professors who refused the loyalty oath to Mussolini \u2014 expelled from university, he stayed out of defiance.',

  // --- Characters: Japan ---
  'faction.japonia.a.name': 'Hideyo Noguchi',
  'faction.japonia.a.bio': 'Bacteriologist researching syphilis, yellow fever and snake venoms. His face adorns the 1000 yen banknote. The serum saved him from yellow fever in Ghana \u2014 he returned to Japan.',
  'faction.japonia.b.name': 'Kitasato Shibasaburo',
  'faction.japonia.b.bio': 'Co-discoverer of the plague bacillus. Created the tetanus antitoxin. Founder of the Kitasato Institute \u2014 a pillar of Japanese medicine, mentor to Noguchi.',

  // --- Characters: Yugoslavia ---
  'faction.jugoslawia.a.name': 'Nikola Tesla',
  'faction.jugoslawia.a.bio': 'AC motor, Tesla coil, contributions to radio. Visionary of wireless energy transmission. The serum restored his vigor in New York \u2014 he returned to Yugoslavia to finally serve his homeland.',
  'faction.jugoslawia.b.name': 'Mihajlo Pupin',
  'faction.jugoslawia.b.bio': 'Pioneer of telecommunications \u2014 Pupin coils extended the range of telephony. Columbia University professor. A Serbian patriot who returned from New York to build infrastructure.',

  // --- Characters: Great Britain ---
  'faction.wielka-brytania.a.name': 'Ernest Rutherford',
  'faction.wielka-brytania.a.bio': 'Split the atom (1917), discovered the atomic nucleus. Nobel Prize in Chemistry 1908. Father of nuclear physics. The serum saved him from an absurdly mundane death \u2014 a strangulated hernia.',
  'faction.wielka-brytania.b.name': 'J.J. Thomson',
  'faction.wielka-brytania.b.bio': 'Discoverer of the electron (1897). Nobel Prize in Physics 1906. Head of the Cavendish Laboratory, where he mentored seven future Nobel laureates \u2014 including Rutherford.',

  // --- Scenarios ---
  'scenario.tutorial': 'Tutorial',
  'scenario.tutorial.desc': 'Training map with all building and unit types. 2 players, 20\u00d720.',
  'scenario.battle': 'Battle',
  'scenario.battle.desc': 'Small 16\u00d716 arena, HQ only. 25 units per player \u2014 combat from turn one.',
  'scenario.size.small': 'Small',
  'scenario.size.medium': 'Medium',
  'scenario.size.large': 'Large',
  'scenario.size.xlarge': 'Extra Large',
  'scenario.mapInfo': '{0} map, {1} players, {2}\u00d7{3}.',

  // --- Main menu ---
  'menu.subtitle': 'isometric turn-based game',
  'menu.newGame': 'New Game',
  'menu.tutorial': 'Tutorial',
  'menu.settings': 'Settings',
  'menu.loadGame': 'Load game',
  'menu.exitGame': 'Exit game',
  'menu.exitConfirm': 'Are you sure you want to exit?',
  'menu.yes': 'Yes',
  'menu.no': 'No',
  'menu.hint': 'objective: capture all enemy buildings',
  'menu.tutorialExperimentalTitle': 'Tutorial — heads-up',
  'menu.tutorialExperimentalBody': 'Tutorials are not finished yet and are an experimental feature. They may contain bugs or unfinished parts.',
  'menu.tutorialExperimentalAck': 'Acknowledged',

  // --- Tutorial ---
  'tutorial.header': 'TUTORIAL',
  'tutorial.lessons': 'Lessons',
  'tutorial.startLesson': 'Start lesson',
  'tutorial.back': 'Back',
  'tutorial.victoryTitle': 'LESSON COMPLETE!',
  'tutorial.nextLesson': 'Next lesson →',
  'tutorial.backToLessons': 'Back to lessons',
  'tutorial.lesson.1.name': 'Movement',
  'tutorial.lesson.1.desc': 'Learn to select units and move them across the map. Understand movement range, terrain costs, and how roads affect speed.',
  'tutorial.lesson.2.name': 'Combat',
  'tutorial.lesson.2.desc': 'Learn attack and counter-attack mechanics. Discover how terrain and buildings affect defense, and how to read the damage preview.',
  'tutorial.lesson.3.name': 'Capturing buildings',
  'tutorial.lesson.3.desc': 'Learn to capture neutral and enemy buildings with infantry. Understand city income and strategic importance.',
  'tutorial.lesson.4.name': 'Recruitment & economy',
  'tutorial.lesson.4.desc': 'Master unit recruitment in barracks, factories, and airports. Learn gold management and production planning.',
  'tutorial.lesson.5.name': 'Healing & resupply',
  'tutorial.lesson.5.desc': 'Discover medics that heal wounded units and supply trucks that replenish ammunition.',
  'tutorial.lesson.6.name': 'Unit transport',
  'tutorial.lesson.6.desc': 'Learn to load units into transports (APC, ships) and unload them in the field.',
  'tutorial.lesson.7.name': 'Building bunkers',
  'tutorial.lesson.7.desc': 'Learn to build bunkers with a supply truck. Construction takes 2 turns and provides a strong defense bonus.',

  'tutorial.stepCounter': 'STEP {0} of {1}',

  // Tutorial 1: Movement
  'tutorial.movement.name': 'Tutorial: Movement',
  'tutorial.movement.desc': 'Learn to select and move units.',
  'tutorial.movement.story': 'Welcome, commander! Learn how to move your units. Follow the instructions in the banner at the top of the screen.',
  'tutorial.movement.step1': '\ud83d\udc46 Click on your infantry to select it',
  'tutorial.movement.step2': '\ud83d\uddfa\ufe0f Click "Move" in the bottom panel, then click the highlighted tile',
  'tutorial.movement.complete': 'Well done! The infantry reached its destination. Roads speed up unit movement.',

  // Tutorial 2: Combat
  'tutorial.combat.name': 'Tutorial: Combat',
  'tutorial.combat.desc': 'Learn to attack enemies \u2014 soften with artillery, finish with infantry.',
  'tutorial.combat.story': 'You have artillery and infantry. Artillery fires far (3\u20135 tiles) but cannot attack up close. Soften the enemy with artillery, then finish them off with infantry!',
  'tutorial.combat.step1': '\ud83c\udfaf Click the artillery to select it',
  'tutorial.combat.step2': '\ud83d\udca5 Click "Attack", then click the enemy \u2014 artillery fires from range!',
  'tutorial.combat.step3': '\ud83d\udc46 The enemy is weakened! Now click your infantry',
  'tutorial.combat.step4': '\ud83d\uddfa\ufe0f Move closer to the enemy \u2014 click "Move", then the highlighted tile',
  'tutorial.combat.step5': '\u2694\ufe0f Finish the enemy! Click "Attack", then click on them',
  'tutorial.combat.complete': 'Well done! Artillery softened the enemy from range, infantry finished them off. Combining forces is the key to victory!',

  // Tutorial 3: Capturing buildings
  'tutorial.capture.name': 'Tutorial: Capturing Buildings',
  'tutorial.capture.desc': 'Three unit types can capture buildings \u2014 infantry, bazooka infantry, and cavalry.',
  'tutorial.capture.story': 'Buildings generate gold and enable recruitment. Three unit types can capture them: infantry, bazooka infantry, and cavalry. Capturing requires 2 turns on the building.',
  'tutorial.capture.groupT1': '\ud83d\udc46 Click any unit on a building, then click "Capture"',
  'tutorial.capture.groupT2': '\ud83d\udc46 Select a unit and finish capturing (turn 2)',
  'tutorial.capture.t1.inf.select': '\ud83d\udc46 Click the infantry to select it',
  'tutorial.capture.t1.inf.capture': '\ud83d\udea9 Click "Capture" \u2014 infantry begins capturing the city',
  'tutorial.capture.t1.baz.select': '\ud83d\udc46 Click the bazooka infantry',
  'tutorial.capture.t1.baz.capture': '\ud83d\udea9 Click "Capture" \u2014 bazooka can capture buildings too!',
  'tutorial.capture.t1.cav.select': '\ud83d\udc46 Click the cavalry \u2014 a fast unit',
  'tutorial.capture.t1.cav.capture': '\ud83d\udea9 Click "Capture" \u2014 cavalry can also capture buildings!',
  'tutorial.capture.endTurn': '\u23ed\ufe0f Capturing requires 2 turns. End your turn',
  'tutorial.capture.t2.inf.select': '\ud83d\udc46 Click the infantry again',
  'tutorial.capture.t2.inf.capture': '\ud83d\udea9 Click "Capture" \u2014 the second turn completes the capture!',
  'tutorial.capture.t2.baz.select': '\ud83d\udc46 Click the bazooka infantry',
  'tutorial.capture.t2.baz.capture': '\ud83d\udea9 Click "Capture" to finish capturing',
  'tutorial.capture.t2.cav.select': '\ud83d\udc46 Click the cavalry',
  'tutorial.capture.t2.cav.capture': '\ud83d\udea9 Click "Capture" \u2014 the last building!',
  'tutorial.capture.complete': 'All buildings captured! Infantry, bazooka, and cavalry can all capture buildings.',

  // Tutorial 4: Recruitment
  'tutorial.recruitment.name': 'Tutorial: Recruitment',
  'tutorial.recruitment.desc': 'Learn to recruit new units in buildings.',
  'tutorial.recruitment.story': 'You have 200 gold and barracks. Recruit an infantry! Click on the barracks and choose a unit to produce. Follow the instructions in the banner above.',
  'tutorial.recruitment.step1': '\ud83c\udfed Click on the barracks (building with a flag)',
  'tutorial.recruitment.step2': '\ud83c\udf96\ufe0f Click the "Infantry" card in the recruitment panel below',
  'tutorial.recruitment.step3': '\u23ed\ufe0f End your turn \u2014 the infantry will appear at the barracks',
  'tutorial.recruitment.complete': 'Infantry ready! Now you can move it.',

  // Tutorial 5: Healing & Resupply
  'tutorial.healing.name': 'Tutorial: Healing & Resupply',
  'tutorial.healing.desc': 'Learn about medics and supply trucks.',
  'tutorial.healing.story': 'Medics heal wounded units within 1 tile. Supply trucks replenish ammo for nearby units. Without supplies, units fight and move at half efficiency!',
  'tutorial.healing.step1': '\ud83d\udc46 Click the medic to select it',
  'tutorial.healing.step2': '\u2764\ufe0f Click "Heal" \u2014 the medic will heal the wounded infantry nearby',
  'tutorial.healing.healDone': 'Great! The medic healed the infantry. Medics heal all friendly units within 1 tile.',
  'tutorial.healing.step3': '\ud83d\udc46 Click the supply truck',
  'tutorial.healing.step4': '\ud83d\udce6 Click "Resupply" \u2014 the truck will resupply the nearby infantry',
  'tutorial.healing.complete': 'Excellent! Supplies replenished. Units without supplies have halved attack power and movement range.',

  // Tutorial 6: Transport
  'tutorial.transport.name': 'Tutorial: Unit Transport',
  'tutorial.transport.desc': 'Learn to load and unload units from transports.',
  'tutorial.transport.story': 'Transports carry infantry and other units. APCs travel on land, transport ships sail on water. Load infantry into the APC, then transport another unit across water by ship!',
  'tutorial.transport.step1': '\ud83d\udc46 Click the infantry next to the APC',
  'tutorial.transport.step2': '\ud83d\ude9a Click "Move", then click on the APC \u2014 the infantry will load automatically',
  'tutorial.transport.loadDone': 'Infantry loaded! The APC can now carry it faster across the map.',
  'tutorial.transport.seaLoadDone': 'Infantry aboard! The ship can now carry it across the water.',
  'tutorial.transport.step3': '\ud83d\udc46 Click the infantry next to the ship',
  'tutorial.transport.step4': '\u26f5 Click "Move", then click on the ship \u2014 infantry will board',
  'tutorial.transport.step5': '\ud83d\udc46 Click the transport ship',
  'tutorial.transport.step6': '\ud83d\uddfa\ufe0f Click "Move" and sail to shore (the highlighted tile)',
  'tutorial.transport.step7': '\ud83d\udea2 Click "Unload" and select a land tile next to the ship',
  'tutorial.transport.complete': 'Well done! You\u2019ve mastered land and sea transport. Transports are key to rapidly deploying forces!',

  // Tutorial 7: Building
  'tutorial.building.name': 'Tutorial: Building Bunkers',
  'tutorial.building.desc': 'Learn to build bunkers with a supply truck.',
  'tutorial.building.story': 'Supply trucks can build bunkers on plains and roads. Construction takes 2 turns \u2014 first turn lays foundations, second turn completes the build. Bunkers provide a strong defense bonus to units stationed inside!',
  'tutorial.building.step1': '\ud83d\udc46 Click the supply truck',
  'tutorial.building.step2': '\ud83d\udd28 Click "Build" \u2014 the truck will start bunker construction',
  'tutorial.building.phase1Done': 'Foundations laid! End your turn to finish construction on the next turn.',
  'tutorial.building.step3': '\u23ed\ufe0f Click "End Turn" to advance to the next turn',
  'tutorial.building.step4': '\ud83d\udc46 Click the supply truck again',
  'tutorial.building.step5': '\ud83d\udd28 Click "Build" \u2014 the truck will complete the bunker',
  'tutorial.building.complete': 'Excellent! Bunker complete. Bunkers provide a strong defense bonus (+250%) to stationed units. Remember \u2014 only supply trucks can build!',

  // --- Campaign ---
  'campaign.header': 'CAMPAIGN',
  'campaign.selectFaction': 'Select faction',
  'campaign.missions': 'Missions',
  'campaign.startMission': 'Start mission',
  'campaign.back': 'Back',
  'campaign.locked': 'Coming soon',
  'campaign.polska.name': 'September Campaign',
  'campaign.polska.desc': 'September 1939 \u2014 defense of Poland against the Third Reich and USSR invasion.',
  'campaign.intro.title': 'The words of Marie Sk\u0142odowska-Curie',
  'campaign.intro.voice': '\ud83d\udd0a Listen',
  'campaign.intro.continue': 'Continue',
  'campaign.polska.intro': 'My name is Marie Sk\u0142odowska-Curie. I was born in Warsaw, when Poland existed on no map \u2014 under partition, in a city that learned to be Polish in secret.\n\nThe radiation to which I gave my life was slowly killing me. The doctors spoke of anemia, of months. Then a parcel arrived from Moscow: a glass vial and Bogdanov\'s letter. The serum could not undo what radium had done \u2014 but it halted the illness. It gave me time.\n\nI could have stayed in Paris, at the Radium Institute, warm in fame and quiet. And yet the element I discovered I named polonium \u2014 for a country that did not then exist. Today that country exists once more. And once more it stands at the edge of the abyss.\n\nBogdanov\'s testament asked that the serum serve peace. I believe that with all my heart. But it is September 1939, and tanks pour into Poland from the west and the east. Science cannot save people if there are no people left.\n\nI am returning to Warsaw. Not to kill \u2014 to heal, to give our soldiers every hour I can. The time I was given, I give to Poland.',
  'campaign.polska.1.name': 'Border Battle',
  'campaign.polska.1.desc': 'September 1, 1939. Repel the enemy assault on the western border. Hold defensive positions as long as possible.',
  'campaign.polska.2.name': 'Defense of Westerplatte',
  'campaign.polska.2.desc': 'The legendary 7-day resistance of 200 Polish soldiers against 3,500 Germans. Defend the depot to the last.',
  'campaign.polska.3.name': 'Battle of the Bzura',
  'campaign.polska.3.desc': 'The largest Polish counter-offensive of the September Campaign. Strike the surprised enemy on the flank.',
  'campaign.polska.4.name': 'Defense of Warsaw',
  'campaign.polska.4.desc': 'Siege of the capital. Defend Warsaw against advancing armored forces and bombardment.',
  'campaign.polska.5.name': 'Battle of Kock',
  'campaign.polska.5.desc': 'The last battle of the September Campaign, October 2\u20135, 1939. The final organized resistance of the Polish Army.',

  // --- Map select ---
  'mapSelect.header': 'NEW GAME',
  'mapSelect.scenarios': 'Scenarios',
  'mapSelect.emptyCatalog': 'No scenarios available.',
  'mapSelect.uploadScenario': '📁 Upload scenario JSON',
  'mapSelect.startGame': 'Start Game',
  'mapSelect.back': 'Back',
  'mapSelect.players': 'Players',
  'mapSelect.playersCount': '{0} players',
  'mapSelect.random': 'Random',
  'mapSelect.pickHint': 'LMB — full picker · RMB — quick list',
  'mapSelect.randomFaction': 'Random',
  'mapSelect.human': 'Human',
  'mapSelect.computer': 'Computer {0}',
  'mapSelect.selectPortrait': 'Select a nation and character to see the portrait',
  'mapSelect.randomFactionLabel': 'Random nation',
  'mapSelect.randomCharacterLabel': 'Random character',
  'mapSelect.noUniqueUnits': 'No unique units',
  'mapSelect.uniqueUnits': 'Unique units',
  'mapSelect.clickToSelect': 'Click to select character',
  'mapSelect.selectCharacter': 'CHARACTER SELECT',
  'mapSelect.confirm': 'Select',
  'recruit.noRecruitment': '\u2014 no recruitment',

  // --- Color names ---
  'color.0': 'Blue',
  'color.1': 'Red',
  'color.2': 'Green',
  'color.3': 'Yellow',
  'color.4': 'Purple',
  'color.5': 'Orange',

  // --- Loading screen ---
  'loading.player': 'Player {0}',
  'loading.you': '(you)',
  'loading.ai': '(AI)',
  'loading.preparing': 'Preparing the battlefield...',
  'intro.begin': 'Begin',

  // --- Settings ---
  'settings.title': 'Settings',
  'settings.muteAll': 'Mute all',
  'settings.muted': 'Muted',
  'settings.soundOn': 'Sound on',
  'settings.music': 'Music',
  'settings.sfx': 'Sound effects',
  'settings.aiSpeed': 'AI move speed',
  'settings.scrollSpeed': 'Scroll speed',
  'settings.close': 'Close',
  'settings.saveAndClose': 'Save & exit',
  'settings.cancel': 'Cancel',
  'settings.language': 'Language',
  'settings.display': 'Display',
  'settings.displayMode': 'Display mode',
  'settings.fullscreen': 'Fullscreen',
  'settings.windowed': 'Windowed',
  'settings.resolution': 'Resolution',
  'settings.native': 'Native',

  // --- Confirm dialog ---
  'confirm.cancel': 'Cancel',
  'confirm.ok': 'Confirm',

  // --- HUD top bar ---
  'hud.player': 'Player {0}',
  'hud.objectives': 'Objectives',
  'objective.panelTitle': 'Scenario objectives',
  'objective.victoryHeader': 'Victory',
  'objective.defeatHeader': 'Defeat (avoid)',
  'objective.none': 'No objectives defined — defeat your opponent.',
  'objective.captureHq': 'Capture all enemy HQs',
  'objective.eliminateAll': 'Destroy all enemy units',
  'objective.survive': 'Survive {0} turns',
  'objective.holdBuildings': 'Hold the designated buildings',
  'objective.killUnit': 'Destroy target: {0}',
  'objective.reachTile': 'Get unit {0} to the marked tile',
  'objective.protectUnit': 'Protect {0} for {1} turns',
  'objective.captureBuilding': 'Capture building: {0}',
  'objective.captureGroup': 'Capture group: {0}',
  'objective.holdBuilding': 'Hold building: {0}',
  'objective.holdGroup': 'Hold group: {0}',
  'objective.fail.unitKilled': 'Do not lose unit: {0}',
  'objective.fail.buildingLost': 'Do not lose building: {0}',
  'objective.fail.turnLimit': 'Finish before turn {0}',
  'objective.fail.allUnitsKilled': 'Do not lose all your units',
  'objective.fail.loseGroup': 'Do not lose the entire group: {0}',
  'objective.fail.holdBuilding': 'Do not let the enemy hold: {0}',
  'objective.fail.holdGroup': 'Do not let the enemy hold group: {0}',
  'hud.turn': 'Turn:',
  'hud.gold': 'Gold: {0} (+{1})',
  'hud.unitsShort': '{0}u',
  'hud.buildingsShort': '{0}b',
  'hud.endTurn': 'END TURN',
  'hud.skipAi': 'SKIP MOVES',
  'hud.playerList': 'Player list',
  'hud.messages': 'Messages',
  'hud.frontLine': 'Front line',

  // --- Info panel ---
  'info.terrain': 'Terrain',
  'info.building': 'Building',
  'info.unit': 'Unit',
  'info.clickMap': 'Click on map to display info',
  'info.neutral': 'Neutral',
  'info.training': 'Training: {0} ({1})',
  'info.noBuilding': 'No building',
  'info.noUnit': 'No unit',
  'info.damage': 'Damage: ~{0}',
  'info.counter': 'Counter: ~{0}',

  // --- Stat names ---
  'stat.attack': 'Attack',
  'stat.defense': 'Defense',
  'stat.hp': 'HP',
  'stat.move': 'Move',
  'stat.range': 'Range',
  'stat.cost': 'Cost',
  'stat.training': 'Training',
  'stat.cargo': 'Cargo',
  'stat.sight': 'Sight',
  'stat.supply': 'Supply',
  'stat.fuel': 'Fuel',
  'stat.ammo': 'Ammo',
  'stat.exp': 'EXP',

  // --- Orders / Actions ---
  'order.move': 'Move',
  'order.attack': 'Attack',
  'order.capture': 'Capture',
  'order.wait': 'Wait',
  'order.end': 'End',
  'order.useMenu': 'Choose an order in the unit menu',
  'order.heal': 'Heal',
  'order.resupply': 'Resupply',
  'order.build': 'Build bunker',
  'order.orders': 'Orders',
  'order.ordersPostMove': 'Post-move orders',
  'order.selectTarget': 'Select target tile',
  'order.confirmMove': 'Click same tile to confirm move',
  'order.pathLength': 'Path: {0}',
  'order.selectAttackTarget': 'Select attack target',
  'order.target': 'Target: {0} (HP: {1}/{2})',
  'order.confirmAttack': 'Click target to confirm attack',
  'order.cancel': 'Cancel',
  'order.unload': 'Unload',
  'order.selectUnloadTile': 'Select unload tile',
  'order.unloadBtn': 'Unload',
  'order.load': 'Load',
  'order.noCargo': 'Empty',
  'order.cargo': 'Cargo',
  'order.selectUnit': 'Select a unit or building',
  'order.aiTurn': 'Opponent\'s turn...',

  // --- Recruitment ---
  'recruit.title': 'Recruitment',
  'recruit.blocked': 'Building is occupied \u2014 recruitment blocked',
  'recruit.trains': 'Training',
  'recruit.cancelTraining': 'Cancel training (refund {0} of cost)',
  'recruit.recruit': 'Recruit',
  'recruit.cancelBtn': 'Cancel',
  'recruit.strongVs': 'Strong against',
  'recruit.weakVs': 'Weak against',
  'recruit.cantAfford': 'Not enough gold',
  'recruit.costLabel': 'Production cost',
  'recruit.timeLabel': 'Production time',

  // --- Messages ---
  'msg.gameStart': 'Game started. Turn 1.',
  'msg.turn': 'Turn {0}',
  'msg.loaded': '{0} loaded into {1}',
  'msg.attacks': '{0} attacks {1}',
  'msg.plane.outOfFuel': '{0} crashed — ran out of fuel',
  'msg.ship.outOfFuel': '{0} ran aground — out of fuel',
  'msg.unloads': '{0} unloads unit',
  'msg.trainingStarted': 'Training started: {0}',
  'msg.trainingCancelled': 'Training cancelled. Refund: {0}g',
  'msg.capturing': 'Capturing {0}',
  'msg.captured': '{0} captured!',
  'msg.ambushed': '{0} walked into an ambush!',
  'combat.ambush': 'Ambush!',
  'msg.healed': '{0} heals nearby units',
  'msg.repaired': '{0} repairs nearby units',
  'msg.resupplied': 'Nearby units resupplied',
  'msg.building': 'Building bunker',
  'msg.buildComplete': 'Bunker completed!',
  'msg.noMessages': 'No messages',

  // --- Modals ---
  'modal.cancelTraining': 'Cancel training?',
  'modal.trainingInfo': '{0} \u2014 {1} turns left',
  'modal.refund': 'Refund: {0}g ({1} of cost)',
  'modal.cancelTrainingBtn': 'Cancel training',
  'modal.no': 'No',
  'modal.victory': 'VICTORY!',
  'modal.defeat': 'DEFEAT',
  'modal.winMessage': 'Player {0} wins in turn {1}',
  'modal.loseMessage': 'Player {0} won in turn {1}',
  'modal.mainMenu': 'Main menu',
  'modal.yourTurn': 'Your turn',
  'modal.ok': 'Ok',
  'modal.gameMenu': 'Game menu',
  'modal.resumeGame': 'Resume game',
  'modal.saveGame': 'Save game',
  'modal.loadGame': 'Load game',
  'modal.quitToMenu': 'Quit game',
  'modal.quitConfirmTitle': 'Confirmation',
  'modal.quitConfirmBody': 'Are you sure you want to return to the main menu? Game progress will be lost.',
  'modal.cancelBtn': 'Cancel',
  'modal.quitBtn': 'Quit',
  'modal.clickToContinue': 'Click to continue',

  // --- Turn report ---
  'report.title': 'FIELD REPORT',
  'report.turn': 'Turn {0} — situation report',
  'report.losses': 'Combat losses',
  'report.noLosses': 'No losses suffered.',
  'report.recruited': 'Reinforcements',
  'report.noRecruited': 'No units recruited.',
  'report.income': 'Revenue',
  'report.noIncome': 'No income this turn.',
  'report.incomeTotal': 'Total: +{0}g',
  'report.acknowledge': 'Acknowledged, sir',

  // --- Scenario dispatch (event message before the turn report) ---
  'dispatch.title': 'INCOMING DISPATCH',
  'dispatch.proceed': 'Proceed to report',
  'briefing.title': 'MISSION BRIEFING',
  'briefing.proceed': 'Begin mission',
  'briefing.close': 'Close',

  // --- Player list ---
  'playerList.title': 'Players',
  'playerList.you': '(you)',

  // --- Plurals ---
  'plural.tile.one': '{0} tile',
  'plural.tile.other': '{0} tiles',
  'plural.availableTile.one': '{0} available tile',
  'plural.availableTile.other': '{0} available tiles',
  'plural.turn.one': '{0} turn',
  'plural.turn.other': '{0} turns',
};
